import { render, staticRenderFns } from "./pass_about.vue?vue&type=template&id=c0ecce24&"
import script from "./pass_about.vue?vue&type=script&lang=js&"
export * from "./pass_about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports